"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
//import LogRocket from 'logrocket';
var CartBadge_1 = __importDefault(require("../cart/CartBadge"));
var AppLinkContainer_1 = __importDefault(require("../common/AppLinkContainer"));
var Brand_1 = __importDefault(require("../common/Brand"));
var UserMenu_1 = __importDefault(require("./UserMenu"));
var UserMenuLoader_1 = __importDefault(require("./UserMenuLoader"));
var Suggest_1 = __importDefault(require("../suggest/Suggest"));
var SuggestPopUp_1 = __importDefault(require("../suggest/SuggestPopUp"));
var ui_1 = require("@aperza/ui");
var util_1 = require("@aperza/util");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var appConfig = util_1.AppService.appConfig();
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query UserMenuQuery {\n    viewer {\n      userId\n      locale\n      serverTime\n      displayName\n      companyName\n      isLogin\n      isBusiness\n      isActiveBusiness\n      buyer {\n        approvalFlag\n      }\n      unreadMessageCount\n    }\n  }\n"], ["\n  query UserMenuQuery {\n    viewer {\n      userId\n      locale\n      serverTime\n      displayName\n      companyName\n      isLogin\n      isBusiness\n      isActiveBusiness\n      buyer {\n        approvalFlag\n      }\n      unreadMessageCount\n    }\n  }\n"])));
var UserSection = function (props) {
    var viewer = props.viewer, suggestSearch = props.suggestSearch, disableSuggest = props.disableSuggest, disableLogin = props.disableLogin, disableCartBadge = props.disableCartBadge;
    var _a = __read(react_1.useState(util_1.AppConfigService.getSearchKeyword() ? util_1.AppConfigService.getSearchKeyword() : ''), 2), suggestKeyword = _a[0], setSuggestKeyword = _a[1];
    var _b = __read(react_1.useState(false), 2), showSuggest = _b[0], setShowSuggest = _b[1];
    var identifyLogRocketUser = function (viewer) {
        if (viewer &&
            !viewer.isInternalIp &&
            viewer.userId &&
            util_1.AppConfigService.shouldInitLogRocket(viewer)) {
            window.aperzaLogRocket(viewer.userId);
        }
    };
    react_1.useEffect(function () {
        identifyLogRocketUser(viewer);
    }, [viewer]);
    var onSuggestChange = function (keyword) {
        setSuggestKeyword(keyword);
    };
    var onClickSuggestPopUp = function () {
        setShowSuggest(!showSuggest);
    };
    var renderSuggest = function () {
        var tdComponentName = 'header_searchBox';
        var suggest = undefined;
        if (!disableSuggest) {
            suggest = (react_1.default.createElement(Suggest_1.default, __assign({ tdId: "td-parts-td-" + tdComponentName, suggestSearch: suggestSearch, suggestKeyword: suggestKeyword, onSuggestChange: onSuggestChange }, props)));
        }
        return suggest;
    };
    var suggest = renderSuggest();
    return (react_1.default.createElement("div", { className: "stripColumn" },
        react_1.default.createElement("div", { className: "aw-main strip" },
            react_1.default.createElement(Brand_1.default, null),
            !disableSuggest && (react_1.default.createElement(ui_1.WebMediaQuery, { desktopOnly: true },
                react_1.default.createElement("div", null, suggest))),
            react_1.default.createElement("div", { className: "util-container" },
                appConfig.isAperzaCatalogTop && react_1.default.createElement(AppLinkContainer_1.default, null),
                !disableSuggest && (react_1.default.createElement(ui_1.WebMediaQuery, { mobileOnly: true },
                    react_1.default.createElement("div", { className: "util-item" },
                        react_1.default.createElement(SuggestPopUp_1.default, { suggest: suggest, onClick: onClickSuggestPopUp })))),
                (!viewer.isBusiness || viewer.isActiveBusinessCart) && (react_1.default.createElement("div", { className: "util-item" }, !disableCartBadge && react_1.default.createElement(CartBadge_1.default, { viewer: viewer }))),
                react_1.default.createElement("div", { className: "util-item" }, !disableLogin && react_1.default.createElement(UserMenuLoader_1.default, { viewer: viewer })))),
        (util_1.AppConfigService.isAperzaSearchResultPage() ||
            util_1.AppConfigService.isAperzaSearchNewsResultPage() ||
            showSuggest) && (react_1.default.createElement("div", { className: "suggest-mobile" }, !disableSuggest && react_1.default.createElement(ui_1.WebMediaQuery, { mobileOnly: true }, suggest)))));
};
UserSection.propTypes = {
    viewer: prop_types_1.default.any,
    suggestSearch: prop_types_1.default.any,
    disableSuggest: prop_types_1.default.bool,
    disableCartBadge: prop_types_1.default.bool,
    disableLogin: prop_types_1.default.bool,
    disableMarketplaceBanner: prop_types_1.default.bool,
};
UserSection.defaultProps = {
    viewer: {},
};
UserSection.fragments = {
    viewer: graphql_tag_1.default(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment UserSection_viewer on Viewer {\n      id\n      userId\n      isInternalIp\n      isLogRocket\n      isLogin\n      isBusiness\n      isActiveBusinessCart\n      ...UserMenu_viewer\n    }\n    ", "\n  "], ["\n    fragment UserSection_viewer on Viewer {\n      id\n      userId\n      isInternalIp\n      isLogRocket\n      isLogin\n      isBusiness\n      isActiveBusinessCart\n      ...UserMenu_viewer\n    }\n    ", "\n  "])), UserMenu_1.default.fragments.viewer),
};
exports.default = UserSection;
var templateObject_1, templateObject_2;
